module.exports = __webpack_public_path__ + "img/s.2dda5d5d.png";